/*
 * Copyright French Prime minister Office/SGMAP/DINSIC/Vitam Program (2019-2022)
 * and the signatories of the "VITAM - Accord du Contributeur" agreement.
 *
 * contact@programmevitam.fr
 *
 * This software is a computer program whose purpose is to implement
 * implement a digital archiving front-office system for the secure and
 * efficient high volumetry VITAM solution.
 *
 * This software is governed by the CeCILL-C license under French law and
 * abiding by the rules of distribution of free software.  You can  use,
 * modify and/ or redistribute the software under the terms of the CeCILL-C
 * license as circulated by CEA, CNRS and INRIA at the following URL
 * "http://www.cecill.info".
 *
 * As a counterpart to the access to the source code and  rights to copy,
 * modify and redistribute granted by the license, users are provided only
 * with a limited warranty  and the software's author,  the holder of the
 * economic rights,  and the successive licensors  have only  limited
 * liability.
 *
 * In this respect, the user's attention is drawn to the risks associated
 * with loading,  using,  modifying and/or developing or reproducing the
 * software by the user in light of its specific status of free software,
 * that may mean  that it is complicated to manipulate,  and  that  also
 * therefore means  that it is reserved for developers  and  experienced
 * professionals having in-depth computer knowledge. Users are therefore
 * encouraged to load and test the software's suitability as regards their
 * requirements in conditions enabling the security of their systems and/or
 * data to be ensured and,  more generally, to use and operate it in the
 * same conditions as regards security.
 *
 * The fact that you are presently reading this means that you have had
 * knowledge of the CeCILL-C license and that you accept its terms.
 */
import { Component, ElementRef, OnChanges, SimpleChanges, input, model, output, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'vitamui-common-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  imports: [CommonModule],
})
export class SearchBarComponent implements OnChanges {
  readonly placeholder = input<string>(undefined);

  readonly name = input<string>(undefined);

  readonly disabled = input(false);

  readonly searchButtonColor = input<'primary' | 'secondary'>('secondary');

  // eslint-disable-next-line @angular-eslint/no-output-native
  readonly search = output<string>();

  readonly searchChanged = output<string>();

  readonly clear = output<string>();

  readonly searchInput = viewChild<ElementRef>('searchInput');

  readonly searchValue = model<string>(undefined);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['searchValue']) {
      this.searchChanged.emit(this.searchValue());
    }
  }

  onInput(value: string) {
    this.searchValue.set(value);
    this.searchChanged.emit(value);
  }

  onSearch() {
    this.search.emit(this.searchValue());
  }

  reset() {
    this.searchValue.set(null);
    // Also clear the input directly: the [value] binding is not updated if it has not been refreshed since the last input
    const searchInput = this.searchInput()?.nativeElement as HTMLInputElement | undefined;
    if (searchInput) searchInput.value = '';
    this.clear.emit(undefined);
    this.search.emit(this.searchValue());
  }

  public onFocus() {
    if (this.searchInput()) {
      setTimeout(() => this.searchInput().nativeElement.focus(), 0);
    }
  }
}
